/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { ErrorMessage } from "formik";
import { iFee, meetingsType, iCommunityProfile } from "ps-shared";
import FormikSwitch from "src/components/Forms/FormikSwitch";
import FormikMultiSelect, { SelectOption } from "src/components/Forms/FormikMultiSelect";
import { FormikMultiCreateSelect } from "src/components/Forms/FormikMultiCreateSelect";
import paymentList from "ps-shared/models/forms/payment.json";
import interestList from "ps-shared/models/forms/communityInterests.json";
import populationList from "ps-shared/models/forms/communityPopulation.json";
import FormikMultiAddress, { ValidationFuncResult } from "src/components/Forms/FormikMultiAddress";
import commonCurrencies from "ps-shared/models/forms/commonCurrencies.json";
import specialties from "ps-shared/models/forms/specialties.json";
import Switch from "react-bootstrap-switch";
import { FormikMoneyRangeSlider } from "src/components/Forms/FormikMoneyRangeSlider";
import { RangeSliderValue } from "src/components/Forms/RangeSlider";
import { FormGroup, Label, UncontrolledTooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";

interface MeetingsProps {
  values: meetingsType;
  profile: iCommunityProfile;
}

interface MeetingsState {
  interest: SelectOption[];
  paymentOptions: SelectOption[];
  population: SelectOption[];
  shareFees: boolean;
  rangeDefault: RangeSliderValue;
  commonCurrencies: SelectOption[];
  specialties: SelectOption[];
}
export default class Meetings extends React.Component<MeetingsProps, MeetingsState> {
  private autocomplete: any;

  private autocompleteListener: any;

  constructor(props: MeetingsProps) {
    super(props);
    this.state = {
      interest: interestList.map((interest: any) => {
        const opt = {} as SelectOption;
        opt.label = interest;
        opt.value = interest;
        return opt;
      }),
      paymentOptions: paymentList.map((payment: any) => {
        const opt = {} as SelectOption;
        opt.label = payment;
        opt.value = payment;
        return opt;
      }),
      population: populationList.map((pop: any) => {
        const opt = {} as SelectOption;
        opt.label = pop;
        opt.value = pop;
        return opt;
      }),
      rangeDefault: {
        min: 20,
        max: 30,
      },
      commonCurrencies: commonCurrencies.map((currency: string) => {
        return {
          value: currency,
          label: currency,
        } as SelectOption;
      }),
      specialties: specialties.map((specialty: string) => {
        return {
          value: specialty,
          label: specialty,
        } as SelectOption;
      }),
      shareFees: !!this.props.values.fee,
    };
    this.autocomplete = null;
    this.handleFeeSwitch = this.handleFeeSwitch.bind(this);
  }

  public handleFeeSwitch(state: boolean) {
    if (!state) {
      this.props.values.fee = null;
    } else {
      this.props.values.fee = {
        min: this.state.rangeDefault.min,
        max: this.state.rangeDefault.max,
        currency: this.state.commonCurrencies[0].value,
      } as iFee;
    }
    this.setState({
      shareFees: state,
    });
  }

  public componentWillUnmount() {
    if (this.autocompleteListener) {
      this.autocompleteListener.remove();
    }
  }

  // tslint:disable:max-line-length
  public render() {
    return (
      <>
        <FormGroup className="mb-3">
          <Label for="locations">Meeting Addresses:</Label>
          <br />
          <FormikMultiAddress
            max={5}
            values={this.props.values.locations}
            name="locations"
            placeHolder="Start typing city then state"
            validationFunc={(val) => {
              if (val.city && val.region && val.country) {
                return {
                  valid: true,
                } as ValidationFuncResult;
              }
              return {
                valid: false,
                err: "You must provide city, state and country",
              } as ValidationFuncResult;
            }}
          />
          <ErrorMessage name="locations" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="online">Do you offer online meetings?</Label>&nbsp;&nbsp;
          <FormikSwitch name="online" onText="Yes" offText="No" />
          <br />
          <ErrorMessage name="online" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="inPerson">Do you offer In-Person meetings?</Label>&nbsp;&nbsp;
          <FormikSwitch name="inPerson" onText="Yes" offText="No" />
          <br />
          <ErrorMessage name="inPerson" component="div" className="form-feedback" />
        </FormGroup>
        <FormGroup className="mb-3">
          <UncontrolledTooltip delay={0} placement="right" target="acceptingTT">
            If 'no' is selected, the contact form (emails) on your profile will be disabled.
          </UncontrolledTooltip>
          <Label for="acceptingClients">Are you currently accepting members?</Label>&nbsp;
          <span id="acceptingTT" style={{ fontSize: "10px" }}>
            <FontAwesomeIcon icon={faInfoCircle} />
          </span>
          &nbsp;&nbsp;
          <FormikSwitch name="acceptingClients" onText="Yes" offText="No" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="intakeAssessmentReqd">Is there an intake assessment?</Label>&nbsp;&nbsp;
          <FormikSwitch name="intakeAssessmentReqd" onText="Yes" offText="No" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="slidingScale">Is your fee sliding scale?</Label>&nbsp;&nbsp;
          <FormikSwitch name="slidingScale" onText="Yes" offText="No" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="slidingScale">Do you want to publish your fee range?</Label>
          <Switch
            defaultValue={this.state.shareFees}
            offColor="primary"
            offText="No"
            onColor="primary"
            onText="Yes"
            onChange={(state) => {
              this.handleFeeSwitch(state.state.value);
            }}
          />
        </FormGroup>
        {this.state.shareFees && (
          <FormGroup className="mb-3">
            <Label for="fee">Fee Range:</Label>
            <br />
            <FormikMoneyRangeSlider
              currencyValue={this.props.values.fee ? this.props.values.fee.currency : null}
              currencyOptions={this.state.commonCurrencies}
              value={this.props.values.fee ? this.props.values.fee : this.state.rangeDefault}
              name="fee"
              min={0}
              max={250}
            />
          </FormGroup>
        )}
        <FormGroup className="mb-3">
          <Label for="payment">Payment Options:</Label>
          <br />
          <FormikMultiSelect options={this.state.paymentOptions} value={this.props.values.payment} name="payment" />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="specialties">Participant conditions:</Label>
          <br />
          <FormikMultiSelect
            options={this.state.specialties}
            value={this.props.values.specialties}
            name="specialties"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="communityInterests">Community Group Interests:</Label>
          <br />
          <FormikMultiCreateSelect
            options={this.state.interest}
            value={this.props.values.communityInterest}
            name="communityInterests"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          <Label for="population">Patient Population:</Label>
          <br />
          <FormikMultiCreateSelect
            options={this.state.population}
            value={this.props.values.population}
            name="population"
          />
        </FormGroup>
      </>
    );
  }
}
